import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchVouchersReport } from "../api/fetchVouchersReport/fetchVouchersReportApi";
import {
  FetchVouchersReportParams,
  VouchersReportItem,
} from "../api/fetchVouchersReport/types";
import { AppDispatch, AppThunk } from "@/app/store";

interface VouchersReportState {
  items: VouchersReportItem[];
  totalCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: VouchersReportState = {
  items: [],
  totalCount: 0,
  loading: false,
  error: null,
};

const vouchersReportSlice = createSlice({
  name: "vouchersReport",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    setReport: (
      state,
      action: PayloadAction<{
        items: VouchersReportItem[];
        totalCount: number;
      }>,
    ) => {
      state.items = action.payload.items;
      state.totalCount = action.payload.totalCount;
    },
  },
});

export const { setLoading, setError, setReport } = vouchersReportSlice.actions;

export const fetchVouchersReportAction =
  (params: FetchVouchersReportParams = {}): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await fetchVouchersReport(params);
      dispatch(
        setReport({
          items: response.data,
          totalCount: response.meta?.totalCount ?? 0,
        }),
      );
    } catch (error) {
      dispatch(
        setError(
          error instanceof Error
            ? error.message
            : "Failed to fetch vouchers report",
        ),
      );
    } finally {
      dispatch(setLoading(false));
    }
  };

export default vouchersReportSlice.reducer;
